module.exports = __webpack_public_path__ + "img/oval.be00fc4a.svg";